import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoading: false,
  errorMsg: "",
  userProfileDetails: null,
};

const profileSlice = createSlice({
  name: "profile",
  initialState,
  reducers: {
    // get verification checks
    getProfileStart: (state) => {
      state.isLoading = true;
      state.errorMsg = "";
    },
    getProfileSuccess: (state, { payload }) => {
      state.isLoading = false;
      state.errorMsg = "";
      state.userProfileDetails = payload;
    },
    getProfileFail: (state, { payload }) => {
      state.isLoading = false;
      state.errorMsg = payload;
    },
  },
});

export const { getProfileStart, getProfileSuccess, getProfileFail } =
  profileSlice.actions;

export const profileReducer = profileSlice.reducer;
